export const SAMPLE_ASYNC = `<app-component-using-position [position]="geolocation$ | async"></app-component-using-position>`;
